import React, { useState, useCallback, useEffect } from 'react'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import AccountsService from '../../services/accounts.service'
import Loading from 'custom/assets/loaders/Loading'
import { useTranslation } from 'react-i18next'
import { LANDING_KEYS, MENU_SIDEBAR_KEYS } from '../../utils/translation-constants'

export default function Offers() {
  const [offers, setOffers] = useState([])
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    fetchOffers()
  }, [])

  const fetchOffers = useCallback(async () => {
    try {
      setStage(0)
      const response = await AccountsService.getOffers()
      setOffers(response.offers)
      setStage(1)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setStage(1)
    }
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderOffers()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderOffers() {
    return (
      <div className=''>
        {offers.length > 0 ? (
          offers.map((item, index) => (
            <div className='rectangle container' key={index}>
              <div className=''>
                <img
                  src={`data:image/png;base64, ${item.offerImage}`}
                  width='100%'
                  height='220'
                  style={{ marginTop: '10px' }}
                  alt='offers'
                />
              </div>
              <div>
                <h5 className='title-here'>{item.offerName}</h5>
                <p className='offerspara'>{item.offerText}</p>
              </div>
            </div>
          ))
        ) : (
          <p>{t(LANDING_KEYS.NO_RECORD)}</p>
        )}
      </div>
    )
  }

  return (
    <div>
      <LayoutWithOutAccountCard breadCumKey='OFFERS' keyPath={'OFFERS'} showEmptySpace={true}>
        <div className=''>
          <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.OFFERS)}</div>
          {renderSwitch()}
        </div>
      </LayoutWithOutAccountCard>
    </div>
  )
}
